import "core-js/modules/es.array.push.js";
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, isRef as _isRef, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../assets/image/label/1.png';
import _imports_1 from '../assets/image/label/2.png';
import _imports_2 from '../assets/image/label/3.png';
import _imports_3 from '../assets/image/label/4.png';
import _imports_4 from '../assets/image/close.png';
const _withScopeId = n => (_pushScopeId("data-v-37d373b1"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = {
  class: "icon"
};
const _hoisted_4 = ["src"];
const _hoisted_5 = {
  class: "selectIcon"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "name"
};
const _hoisted_8 = {
  key: 0,
  class: "tips"
};
const _hoisted_9 = {
  key: 1,
  class: "label-bar"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1));
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
}, null, -1));
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  alt: ""
}, null, -1));
const _hoisted_14 = {
  class: "tk-main-QEcode"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  alt: ""
}, null, -1));
const _hoisted_16 = [_hoisted_15];
const _hoisted_17 = {
  class: "tk-exit-name"
};
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "tk-exit-title"
}, "选择聊天室", -1));
const _hoisted_19 = {
  class: "tk-exit-from"
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "name"
}, "新版六合聊天室", -1));
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "more"
}, null, -1));
const _hoisted_22 = [_hoisted_20, _hoisted_21];
const _hoisted_23 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "name"
}, "旧版六合聊天室", -1));
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "more"
}, null, -1));
const _hoisted_25 = [_hoisted_23, _hoisted_24];
import { onBeforeMount } from "vue";
import { useStore } from "vuex";
import { roomList } from "@/utils/https/wechar";
import Dialog from "@/components/mode/message.js";
import { useRoute } from "vue-router";

import { ref, reactive, onMounted } from 'vue';
import { useRouter } from 'vue-router';
export default {
  __name: 'tabbar',
  setup(__props) {
    let show = ref(false);
    const store = useStore(); //获取vuex

    const tabbar = ref([{
      icon: require("@/assets/image/tabbar/page.png"),
      name: "首页",
      selectIcon: require("@/assets/image/tabbar/pageselect.png"),
      path: "/index"
    }, {
      icon: require("@/assets/image/tabbar/fx.png"),
      name: "发现",
      selectIcon: require("@/assets/image/tabbar/fsselect.png"),
      path: "/discover"
    }, {
      icon: require("@/assets/image/wechar.png"),
      name: "聊天室",
      selectIcon: require("@/assets/image/wechar.png"),
      path: ""
    }, {
      icon: require("@/assets/image/tabbar/xb.png"),
      name: "平台",
      selectIcon: require("@/assets/image/tabbar/xbselect.png"),
      path: "/platform"
    }, {
      icon: require("@/assets/image/tabbar/me.png"),
      name: "我的",
      selectIcon: require("@/assets/image/tabbar/meselect.png"),
      path: "/me"
    }]);
    let gameShow = ref(false);
    var listRoom = [];
    let wechar = item => {
      if (item.name == "聊天室") {
        if (localStorage.getItem("room_info")) {
          list = JSON.parse(localStorage.getItem("room_info"));
          //   console.log(list);
          //   if (list.length == 1) {
          //     gameShow.value = true;
          //     // listRoom.push({ title: list[0].name, id: list[0].id });
          //     // router.push({
          //     //     path:'/wechat',
          //     //     query:{
          //     //         title:list[0].name,
          //     //         id:list[0].id
          //     //     }
          //     // })
          //   } else if (list.length == 0) {
          //     Dialog("暂无聊天列表");
          //   } else {
          //     gameShow.value = true;
          //   }
          gameShow.value = true;
        } else {
          gameShow.value = true;
        }
      }
    };
    let list = reactive([]);
    let roomLists = () => {
      roomList().then(res => {
        list.length = 0;
        let datas = res.data.data;
        if (datas.length == 1) {
          show.value = true;
          listRoom.push({
            title: datas[0].name,
            id: datas[0].id
          });
        } else if (datas.length == 0) {
          Dialog("暂无聊天列表");
        } else {
          gameShow.value = true;
        }
        datas.forEach((item, index) => {
          switch (item.id) {
            case 1:
              list.push({
                name: item.name,
                id: item.id,
                selectIcon: require("@/assets/image/major/provice/2028.png")
              });
              break;
            case 2:
              list.push({
                name: item.name,
                id: item.id,
                selectIcon: require("@/assets/image/major/provice/2015.png")
              });
              break;
            case 3:
              list.push({
                name: item.name,
                id: item.id,
                selectIcon: require("@/assets/image/major/provice/2029.png")
              });
              break;
            case 4:
              list.push({
                name: item.name,
                id: item.id,
                selectIcon: require("@/assets/image/major/provice/2019.png")
              });
              break;
            case 5:
              list.push({
                name: item.name,
                id: item.id,
                selectIcon: require("@/assets/image/major/provice/2015.png")
              });
              break;
            default:
              break;
          }
        });
        localStorage.setItem("room_info", JSON.stringify(list));
      });
    };
    let msg = ref(store.state.msg);
    const router = useRouter();
    let selecRoom = item => {
      //选择聊天室

      router.push({
        path: "/wechat",
        query: {
          title: item.name,
          id: item.id
        }
      });
    };
    let selecRooms = id => {
      if (id == 1) {
        router.push({
          path: "/wechat",
          query: {
            title: "六合聊天室",
            id: 5
          }
        });
      } else {
        router.push({
          path: "/wechat/liuhe"
        });
      }
    };
    const route = useRoute();
    const showTipsbs = ref(false);
    let canGoForward = ref(false);
    onMounted(async () => {
      if (localStorage.getItem("label") || route.query.label) {
        showTipsbs.value = true;
      } else {
        showTipsbs.value = false;
      }
      canGoForward.value = window.history.length > 1; // 检查是否有前进的历史记录
    });

    let goBack = () => {
      //返回上一页
      router.go(-1);
    };
    let goForward = () => {
      //前进
      router.go(1);
      // window.history.forward();
    };

    let refreshPage = () => {
      //刷新页面
      window.location.reload();
    };
    let sharePage = () => {
      //复制链接分享
      const url = window.location.href;
      if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(() => {
          showToast("网址复制成功 快去分享好友吧");
          console.log("Link copied successfully");
        }).catch(error => {
          console.error("Error copying link:", error);
          showToast("复制链接失败，请手动复制！");
        });
      } else {
        // 如果浏览器不支持 clipboard API，使用备用方法
        const input = document.createElement("input");
        input.value = url;
        document.body.appendChild(input);
        input.select();
        document.execCommand("copy");
        document.body.removeChild(input);
        showToast("网址复制成功 快去分享好友吧");
      }
    };
    const tabarShow = ref(true);
    router.beforeEach((to, from) => {
      if (to.name == "indexs" || to.name == "discovers" || to.name == "platforms" || to.name == "mes") {
        tabarShow.value = true;
      } else {
        tabarShow.value = false;
      }
    });
    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      const _component_van_col = _resolveComponent("van-col");
      const _component_van_row = _resolveComponent("van-row");
      const _component_van_overlay = _resolveComponent("van-overlay");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", null, [_createElementVNode("div", {
        class: "h",
        style: _normalizeStyle({
          height: _unref(showTipsbs) ? '119px' : '69px'
        })
      }, null, 4), _createElementVNode("div", {
        class: _normalizeClass(_unref(tabarShow) || _unref(showTipsbs) ? 'tabbar' : 'tabbar tabbar-tow'),
        style: _normalizeStyle({
          boxShadow: _unref(tabarShow) || !_unref(showTipsbs) ? '0 -5px 2px rgba(3, 159, 76, 0.1)' : 'none'
        })
      }, [_unref(tabarShow) ? (_openBlock(), _createElementBlock("ul", _hoisted_1, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(tabbar), (item, index) => {
        return _openBlock(), _createElementBlock("li", {
          class: "item",
          key: index,
          onClick: $event => _unref(wechar)(item)
        }, [_createVNode(_component_router_link, {
          "active-class": "activeIndex",
          to: item.path
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("img", {
            src: item.icon,
            alt: ""
          }, null, 8, _hoisted_4)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
            class: "imgs",
            src: item.selectIcon,
            alt: ""
          }, null, 8, _hoisted_6)]), _createElementVNode("div", _hoisted_7, _toDisplayString(item.name), 1)]),
          _: 2
        }, 1032, ["to"]), item.name == '我的' && _unref(msg) > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createElementVNode("p", null, _toDisplayString(_unref(msg)), 1)])) : _createCommentVNode("", true)], 8, _hoisted_2);
      }), 128))])) : _createCommentVNode("", true), _unref(showTipsbs) ? (_openBlock(), _createElementBlock("div", _hoisted_9, [_createVNode(_component_van_row, null, {
        default: _withCtx(() => [_createVNode(_component_van_col, {
          span: "6",
          onClick: _unref(goBack)
        }, {
          default: _withCtx(() => [_hoisted_10]),
          _: 1
        }, 8, ["onClick"]), _createVNode(_component_van_col, {
          span: "6",
          onClick: _unref(goForward)
        }, {
          default: _withCtx(() => [_hoisted_11]),
          _: 1
        }, 8, ["onClick"]), _createVNode(_component_van_col, {
          span: "6",
          onClick: _unref(refreshPage)
        }, {
          default: _withCtx(() => [_hoisted_12]),
          _: 1
        }, 8, ["onClick"]), _createVNode(_component_van_col, {
          span: "6",
          onClick: _unref(sharePage)
        }, {
          default: _withCtx(() => [_hoisted_13]),
          _: 1
        }, 8, ["onClick"])]),
        _: 1
      })])) : _createCommentVNode("", true)], 6)]), _createVNode(_component_van_overlay, {
        show: _unref(gameShow),
        "z-index": "1000"
      }, {
        default: _withCtx(() => [_createElementVNode("div", {
          class: "wrapper",
          onClick: _cache[3] || (_cache[3] = _withModifiers($event => _isRef(gameShow) ? gameShow.value = false : gameShow = false, ["stop"]))
        }, [_createElementVNode("div", _hoisted_14, [_createElementVNode("div", {
          class: "colse",
          onClick: _cache[0] || (_cache[0] = (...args) => _ctx.colse && _ctx.colse(...args))
        }, _hoisted_16), _createElementVNode("div", _hoisted_17, [_hoisted_18, _createElementVNode("div", _hoisted_19, [_createElementVNode("ul", null, [_createElementVNode("li", {
          onClick: _cache[1] || (_cache[1] = $event => _unref(selecRooms)(1))
        }, _hoisted_22), _createElementVNode("li", {
          onClick: _cache[2] || (_cache[2] = $event => _unref(selecRooms)(2))
        }, _hoisted_25)])])])])])]),
        _: 1
      }, 8, ["show"])], 64);
    };
  }
};